import boolFromString from './boolFromString';

const buildConfig = (dataset) => {
  const tempConf = {config : {}}
  const keys = Object.keys(dataset).filter(key => key.includes('appLayerConfig'))
  keys.map(k => {
    return tempConf['config'][k] = boolFromString(dataset[k])
  })
  return tempConf
}

export default buildConfig